export enum ResponseType {
  Create,
  Submit,
  Accept,
  AcceptReject,
  Editor
}
